module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-17-3ee64a1c47125168b16ea152f10f31e8.svg";